//  Forked from @material-ui/core@4.11.0 @material-ui/styles@4.10.0
//  The reason is when using multiple/nested theme providers, the counter which is in charge to
//  force uniqueness of class names, has multiple instances in memory, which breaks uniqueness
//  when overriding classes. We replaced that with uuid-4 generator ("getNextHash")

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.default = void 0;
var hasSymbol = typeof Symbol === 'function' && Symbol.for;

var _default = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

exports.default = _default;
